import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import useFetching from "../services/careerService";
import { useMsal } from "@azure/msal-react";

function FileUpload() {
  const { instance } = useMsal();
  const { uploadNewExcelFile, adminJsonInfo } = useFetching();

  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [showAll, setShowAll] = useState(false);

  async function fetchAccountInfo() {
    const response = await adminJsonInfo();
    if (response && response.uploadedFiles) {
      setUploadedFiles(response.uploadedFiles);
    }
  }

  useEffect(() => {
    try {
      fetchAccountInfo();
    } catch (error) {
      console.error(error.message);
    }
  }, [instance]);

  const onDrop = (acceptedFiles) => {
    const formData = new FormData();
    acceptedFiles.forEach((file) => {
      formData.append("file", file);
      async function uploadExcelFile() {
        setIsLoading(true);
        setSuccessMsg("");
        const response = await uploadNewExcelFile(formData);
        if (response.fileName != null) {
          setSuccessMsg("Datei erfolgreich hochgeladen!");
          setErrorMsg("");
        } else if (response === 401) {
          setErrorMsg(
            "Datei konnte nicht hochgeladen werden. Ihnen fehlt die Berechtigung dafür."
          );
        } else {
          setErrorMsg(
            "Datei konnte nicht hochgeladen werden. Bitte überpfrüfe die Datei Struktur."
          );
        }
        setIsLoading(false);
        fetchAccountInfo();
      }
      try {
        uploadExcelFile();
      } catch (error) {
        console.error(error.message);
      }
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xls",
        ".xlsx",
      ],
    },
  });

  return (
    <div>
      {isLoading ? (
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div className="loading-spinner small"></div>
        </div>
      ) : (
        <div {...getRootProps()} className="dropZoneStyle">
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Drop die Excel Datei hier ...</p>
          ) : (
            <p>
              Drag 'n' drop eine Excel Datei hier her, oder klicke um eine
              auszuwählen
            </p>
          )}
        </div>
      )}
      <aside>
        {successMsg ? <p style={{ color: "green" }}>{successMsg}</p> : <div />}
        {errorMsg ? <p style={{ color: "red" }}>{errorMsg}</p> : <div />}
        {uploadedFiles && uploadedFiles.length > 0 && (
          <>
            <h4>Zuletzt hochgeladene Datei:</h4>
            <ul className="last-upload-list">
              {!showAll && (
                <li>
                  {uploadedFiles[uploadedFiles.length - 1].fileName} am{" "}
                  {uploadedFiles[uploadedFiles.length - 1].datum} von{" "}
                  {uploadedFiles[uploadedFiles.length - 1].benutzer}
                </li>
              )}

              {showAll &&
                uploadedFiles
                  .slice()
                  .reverse()
                  .map((file, index) => (
                    <li key={index + 1}>
                      {file.fileName} am {file.datum} von {file.benutzer}
                    </li>
                  ))}
            </ul>
            <div className="show-more">
              {!showAll && uploadedFiles.length > 1 && (
                <button
                  className="basic-button"
                  onClick={() => setShowAll(true)}
                >
                  Mehr anzeigen
                </button>
              )}
              {showAll && uploadedFiles.length > 1 && (
                <button
                  className="basic-button"
                  onClick={() => setShowAll(false)}
                >
                  Weniger anzeigen
                </button>
              )}
            </div>
          </>
        )}
      </aside>
    </div>
  );
}

export default FileUpload;
